module.exports = __webpack_public_path__ + "static/img/card-2.762415a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-2.png
// module id = QaJm
// module chunks = 0